import React from 'react';
import { ScrollView, StyleSheet } from 'react-native';
import { DNABox, DNACard, DNAText, Iffy, InformationMessage } from '@alucio/lux-ui/src';
import colors from '@alucio/lux-ui/src/theming/themes/alucio/colors';
import { useHubsState } from 'src/state/context/Hubs/HubsStateProvider.proxy';
import WidgetContentCard from 'src/screens/Hubs/EditHub/Widgets/WidgetContentCard';
import { useHubRHFromState } from './useHubRHFormStateProvider';
import { sortHubSectionsByOrder } from './hubSections';

const styles = StyleSheet.create({
  contentContainer: {
    backgroundColor: colors['color-gray-10'],
    minWidth: 500,
  },
  innerContainer: {
    width: '100%',
    padding: 16,
    alignSelf: 'center',
  },
  emptyStateCard: {
    borderColor: colors['color-gray-80'],
    borderWidth: 1,
    borderRadius: 4,
    paddingVertical: 27,
    paddingHorizontal: 24,
  },
  informationMessage: {
    marginBottom: 0,
  },
});

const Content: React.FC = () => {
  const { widgets, errorMsgRef } = useHubsState()
  const { rhForm, formErrorMessage } = useHubRHFromState()

  return (
    <DNABox as={ScrollView} fill childFill appearance="col" style={ styles.contentContainer }>
      <DNABox fill appearance="col" spacing="lg" keepSpacingLastItem style={styles.innerContainer}>
        {/* Empty State */}
        <Iffy is={!widgets.length}>
          <DNACard appearance="flat" >
            <DNABox fill alignY="center" style={ styles.emptyStateCard }>
              <DNAText status="subtle">Add sections to see them appear here.</DNAText>
            </DNABox>
          </DNACard>
        </Iffy>
        {/* Widgets Mapping */}
        <Iffy is={widgets.length}>
          {
            formErrorMessage ? (
              <DNABox ref={errorMsgRef}>
                <InformationMessage
                  text={formErrorMessage}
                  variance="danger"
                  customWrapperStyle={styles.informationMessage}
                />
              </DNABox>
            ) : null
          }
          {sortHubSectionsByOrder(widgets).map(widget => {
            return <WidgetContentCard key={widget.id} widget={widget} rhForm={rhForm}/>
          })}
        </Iffy>
      </DNABox>
    </DNABox>
  )
}

export default Content
